import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import axios from "axios";
import { CurrencyDisplay, CustomTable, ModalError } from "components";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { arrayToCommaSeparatedString, getErrors } from "utils";

const ModalDashboardDetail = ({ open, onClose, params }) => {
  const classes = globalStyles();
  const token = localStorage.getItem("token");
  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [pageDetail, setPageDetail] = useState({
    song: "",
    composer_names: [],
    song_usages: [],
  });
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const { song_id, year, month, dsp_ids, name } = params || {};

  const getResponse = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/composer/dashboard/v2/song-usage/detail/${song_id}`,
        {
          headers,
          params: {
            year,
            dsp_ids,
            month,
          },
        }
      );
      const { data } = res?.data;
      const songUsage = data?.song_usages?.map(item => ({
        ...item,
        title: name,
      }));
      setDataTable(songUsage || []);
      setPageDetail(data);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    if (open) {
      getResponse();
    }
  }, [song_id, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogContent className={classes.padding0}>
        {loadingPage ? (
          <Box
            width="300px"
            height="150px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress size={30} />
          </Box>
        ) : (
          <Box>
            <HeaderTitle
              title={
                <Grid container direction="column">
                  <Grid item>
                    <Typography fontSize={24}>
                      Song Title:{" "}
                      <Typography
                        component="span"
                        fontSize={24}
                        fontWeight={700}
                      >
                        {pageDetail?.song_title}
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      fontSize={18}
                    >{`Year of Song Usage: ${year}`}</Typography>
                  </Grid>
                </Grid>
              }
            />
            <Box
              border="1px solid #ebebeb"
              borderRadius="5px"
              p="24px"
              my="16px"
            >
              {songDetailList({ songDetail: pageDetail })?.map(
                (item, index) => (
                  <Grid container key={index} spacing={2}>
                    <Grid item>
                      <Typography>{item?.title}</Typography>
                    </Grid>
                    <Grid item>
                      <Box display="flex">
                        <Typography>
                          {item?.title === "Composer"
                            ? arrayToCommaSeparatedString(item?.name)
                            : item?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )
              )}
            </Box>
            <CustomTable columnTable={columnTable} data={dataTable} />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

const columnTable = [
  {
    name: "publisher_name",
    title: "Publisher",
  },
  {
    name: "dsp_name",
    title: "DSP",
  },
  {
    name: "stream",
    title: "Listener Traffic",
    headerAlign: "right",
    renderText: item => <CurrencyDisplay value={item} decimalScale={2} />,
  },
  {
    name: "revenue",
    title: "Revenue",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay value={item} prefix="Rp " decimalScale={2} />
    ),
  },
];

const songDetailList = ({ songDetail }) => [
  {
    title: "ISRC Code",
    name: arrayToCommaSeparatedString(songDetail?.isrc_codes),
  },
  {
    title: "Composer",
    name: songDetail?.composer_names,
  },
];

export default ModalDashboardDetail;
